import { render, staticRenderFns } from "./Inline.vue?vue&type=template&id=25b591c4"
import script from "./Inline.vue?vue&type=script&lang=ts"
export * from "./Inline.vue?vue&type=script&lang=ts"
import style0 from "./Inline.vue?vue&type=style&index=0&id=25b591c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@7.1.2_@rspack+core@1.7.1_@swc+he_79f595af2fd1e2550f685bb18e5f4d00/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports